import { render, staticRenderFns } from "./ChatQuote.vue?vue&type=template&id=8b0f9aaa&scoped=true"
import script from "./ChatQuote.vue?vue&type=script&lang=js"
export * from "./ChatQuote.vue?vue&type=script&lang=js"
import style0 from "./ChatQuote.vue?vue&type=style&index=0&id=8b0f9aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0f9aaa",
  null
  
)

export default component.exports